<template>
  <div class="pages" v-cloak>
    <headerView  :show-bg="true"></headerView>
    <div class="w960 pagecontent">
        
      <h1 class="text-center title">{{$t('warranty_result')}}</h1>
      <p class="text-center curTime">{{curTime}}</p>

      <div class="goodsList">
        <div class="goodsItem" v-for="(item, index) in goods" :key="index">
           <div class="el-card-item">
              <el-row>
                <el-col :span="16">
                  <el-image
                      class="thumb-image"
                      :src="item.masterUrl"
                      :preview-src-list="[item.masterUrl]"
                      fit="contain"
                    ></el-image>
                  <div class="content">
                    <!-- {{$t('warranty_time')}} -->
                    <p class="txt">{{$t('warranty_name')}}：{{ item.name }}</p>
                    <p class="txt">{{$t('warranty_price')}}：{{item.price/100}}元</p>
                    <p class="txt">{{$t('warranty_barcode')}}：{{item.barcode}}</p>
                    <p class="txt" v-if="item.queryTime">{{$t('warranty_querytime')}}：{{item.queryTime|setDate}}</p>
                  </div>
                </el-col>
                 <el-col :span="8">
                  <div class="rowCenter justify-center">
                    <div class="status" v-for="(child,numb) in item.statusList" :key="numb" :class="child.status">
                      <div class="txt">{{child.title}}</div>
                      <div class="center word">
                        <div class="wordTxt">{{child.txt}}</div>
                      </div>
                    </div>

                  </div>
                </el-col>
              </el-row>
           <div class="line"></div>
            <el-row v-if="item.storesPhone">
                <el-col :span="16">
                  <el-image
                      class="thumb-image"
                      :src="item.storeMasterUrl"
                      :preview-src-list="[item.storeMasterUrl]"
                      fit="contain"
                    ></el-image>
                  <div class="content">
                    <!-- {{$t('warranty_time')}} -->
                    <p class="txt">{{$t('warranty_storename')}}：{{ item.storeName }}</p>
                    <p class="txt">{{$t('warranty_carmodel')}}：{{ item.carModel }}</p>
                    <p class="txt">{{$t('installtime')}}：{{ item.installTime|setDate}}</p>
                    <p class="txt">{{$t('storesphone')}}：{{ item.storesPhone }}</p>
                    <p class="txt">{{$t('storeaddress')}}：{{ item.address }}</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="center code">
                      <img
                        class="code-img"
                        src="@/assets/images/miniprogram_car.png"
                      />
                    <p class="text-sm">{{$t('warranty_scan1')}}</p>
                  </div>
                </el-col>
              </el-row>
              <div class="center mgt15 code" v-else>
                    <img
                      class="code-img"
                      src="@/assets/images/miniprogram_car.png"
                    />
                  <p class="text-sm">{{$t('warranty_scan2')}}</p>
                </div>
           

            </div>
        </div>
      </div>
      <div style="height:100px" v-loading="true" v-if="stateSche==1"></div>
      <div class="text-center" v-if="stateSche==2 || stateSche==3">
        <el-empty :image-size="160" :description="$t('warranty_no')" ></el-empty>
        <el-button plain size="small" style="margin:30px auto;" @click="$router.back()">重新查询</el-button>
      </div>
      
    </div>
     <footView :show-section="false" :show-type="2"></footView>
  </div>
</template>

<script>
import { queryByBarcode, queryByPhone } from "@/request/api";
export default {
  name: "warrantyDetail",
  components: {},
  data() {
    return {
     stateSche: 1,
     phone:"",
     license:"",
     barcode:"",

     curTime:"",
     goods: [],
    };
  },

  created() {},
  mounted() {
     let query=this.$route.query
    if (query) {
      this.phone=query.phone||"";
      this.license=query.license||"";
      this.barcode=query.code||"";
      this.getDataList();
    }
  
   let formNumb=function(numb){
    numb=numb||0;
    return parseInt(numb)>9?numb:"0"+numb
   }
    var date = new Date();
    var year = date.getFullYear();
    var month = formNumb(date.getMonth() + 1);
    var day = formNumb(date.getDate());
    var hour = formNumb(date.getHours());
    var minute = formNumb(date.getMinutes());

    this.curTime=year+"年"+month+"月"+day+"日 "+hour+":"+minute
  },

  methods: {
    getDataList() {
      let that = this;
      that.stateSche = 1;
      let warranty_status1=this.$t('warranty_status1'),
       warranty_status2=this.$t('warranty_status2'),
       status_result1=this.$t('warranty_status_result1'),
       status_result2=this.$t('warranty_status_result2'),
       status_result3=this.$t('warranty_status_result3');

      if(this.barcode){
        queryByBarcode("barcode="+that.barcode).then((res) => {
          if (res.code == 200) {
             let data=res.data;
            data.statusList=[data.isInstall==0?{status:"status-success",title:warranty_status1,txt:status_result1}:{status:"status-primary",title:warranty_status1,txt:status_result2}]
            that.goods =[data];
            that.stateSche = 0;
          } else if (res.code == 204) {
            that.list = null;
            that.stateSche = 2;
          } else {
            that.list = null;
            that.stateSche = 3;
          }
        }).catch(()=>{
              that.goods = null;
              that.stateSche = 2;
          });

      }else{
         queryByPhone("phone="+that.phone+"&license="+that.license).then((res) => {
            if (res.code == 200) {
              let data=res.data;
              let oneDate=24*60*60*1000
              data.forEach(item=>{
                item.statusList=[];
                item.statusList.push(item.isInstall==0?{status:"status-success",title:warranty_status1,txt:status_result1}:{status:"status-primary",title:warranty_status1,txt:status_result2})
                if(item.endTime){
                  let subTime=new Date(item.endTime)-new Date()
                  if(subTime>0){
                    item.statusList.push({status:"status-success",title:warranty_status2,txt:Math.round(subTime/oneDate)})
                  }else{
                    item.statusList.push({status:"status-danger",title:warranty_status2,txt:status_result3})
                  }
                }
                if(item.storeMasterUrl && item.storeMasterUrl.indexOf("https:")){
                  item.storeMasterUrl="https://ups.aesups.com:98/"+item.storeMasterUrl
                }


              })
              that.goods =data;
              that.stateSche = 0;
            } else if (res.code == 204) {
              that.goods = null;
              that.stateSche = 2;
            } else {
              that.goods = null;
              that.stateSche = 3;
            }
          }).catch(()=>{
              that.goods = null;
              that.stateSche = 2;
          });


      }
    },
  },

  filters:{
    setDate(val){
      if(!val){
        return "";
      }
      val=val.replace(/\//g,"-").split(" ")[0].split("-");
      if(!val || val.length==0){
        return "";
      }
      return val[0]+"年"+val[1]+"月"+val[2]+"日"

    },
  },

  watch: { 
    $route (to, from) { 
      if(to.path=="/warranty/detail"){
         this.$router.go(0) 
      }
  }
  },
};
</script>

<style scoped lang="scss">
body{
  background-color: #f6f7f9;
}
.pagecontent {
  padding: 50px 30px 20px;
  font-size: 16px;
  font-weight: 700;
  .title{
    margin-bottom: 12px;
  }
  .curTime{
    margin-bottom: 35px;
  }
}


.goodsList {
  .line{
    width: 70%;
    margin: 20px auto;
    height: 1px;
    background-color: #d6d4d4;
  }
  .goodsItem{
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.3);
    border-radius: 12px;
    overflow: hidden;
    padding: 40px 50px;
    margin-bottom: 30px;
  }
  .thumb-image {
    width: 140px;
    height: 140px;
    margin-right: 20px;
    display: inline-block;
    vertical-align: top;
    border-radius: 2px;
  }
  .content{
    display: inline-block;
    vertical-align: top;
    padding-top: 10px;

    .txt{
      margin-bottom: 4px;
    }
  }


  .name {
    font-size: 15px;
    margin-bottom: 20px;
  }
  time{
    color: #999;
    font-size: 13px;
  }

//  

// status-primary
.status{
  width: 110px;
  border: solid 1px #004ba0;
  color:#004ba0;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  overflow: hidden;
  align-self: flex-end;
  margin-top: 16px;
  .txt{
    background-color: #004ba0;
    color: #fff;
    line-height: 36px;
  }
  .word{
    height: 58px;

  }
}
.status-success {
  border-color: #07863a;
  color: #07863a;
  .txt{
      background-color: #07863a;
  }
 .wordTxt::after{
    content: " 天";
    font-size: 12px;
  }

}
.status-danger {
  border-color: #bb0c2d;
  color: #bb0c2d;
  .txt{
      background-color: #bb0c2d;
  }
}

 


.status+.status{
  margin-left: 15px;
}

.code-img{
  width: 110px;
  height: 110px;
  margin-bottom: 12px;
}

}
</style>